import { QueryKeys } from "@/constants/Query";
import { useUser } from "@/network/useUser";
import { socketsAtom } from "@/store/socketsAtom";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

export function useAsyncMessageSocketEvents() {
  const socket = useAtomValue(socketsAtom)?.chat;
  const queryClient = useQueryClient();
  // Consider if enabled: false is still the right approach here
  const { data: user } = useUser({ enabled: false });

  useEffect(() => {
    // Only attach listeners if the socket is ready and user data is available
    if (!socket || !user) return;

    const handleAsyncMessageNotification = () => {
      queryClient.invalidateQueries({
        queryKey: QueryKeys.Provider.AsyncMessageDashboard.DEFAULT,
      });
    };

    // This handler now specifically joins the async message room
    const handleConnect = () => {
      socket.emit("join_async_message_dashboard_room", {
        providerUserId: user.userId,
      });
    };

    // Attach listeners
    socket.on("connect", handleConnect);
    socket.on("async_message_notification", handleAsyncMessageNotification);

    // If already connected when the effect runs, join the room immediately
    if (socket.connected) {
      handleConnect();
    }

    // Cleanup listeners on unmount
    return () => {
      socket.off("connect", handleConnect);
      socket.off("async_message_notification", handleAsyncMessageNotification);
      // Consider emitting a "leave" event if the backend supports/requires it
      // if (socket.connected) {
      //   socket.emit("leave_async_message_dashboard_room", { providerUserId: user.userId });
      // }
    };
  }, [socket, queryClient, user]);

  // This hook performs side effects only
  return null;
}
